import { NgModule } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

import { AccordionComponent } from '@app/shared/modules/accordion/components/accordion.component';
import { AccordionHeaderDirective } from '@app/shared/modules/accordion/directives/accordion-header.directive';
import { AccordionCollapsedContentDirective } from '@app/shared/modules/accordion/directives/accordion-collapsed-content.directive';
import { AccordionExpandedContentDirective } from '@app/shared/modules/accordion/directives/accordion-expanded-content.directive';
import { AccordionGroupDirective } from '@app/shared/modules/accordion/directives/accordion-group.directive';
import { AccordionToggleDirective } from '@app/shared/modules/accordion/directives/accordion-toggle.directive';
import { SharedDirectivesModule } from '@app/shared/shared-directives.module';

@NgModule({
  declarations: [
    AccordionComponent,
    AccordionGroupDirective,
    AccordionHeaderDirective,
    AccordionToggleDirective,
    AccordionExpandedContentDirective,
    AccordionCollapsedContentDirective,
  ],
  exports: [
    AccordionComponent,
    AccordionGroupDirective,
    AccordionHeaderDirective,
    AccordionToggleDirective,
    AccordionExpandedContentDirective,
    AccordionCollapsedContentDirective,
  ],
  imports: [NgTemplateOutlet, SharedDirectivesModule],
})
export class AccordionModule {}
